/* ALLUP-SHOP DS — c-featured-blog-dots.js
 * Featured-blog (brand) カルーセルのドット型ページネーション active 状態管理。
 * SliderComponent は "1 / N" カウンタのみ更新し、dot の active class を管理しない。
 * このスクリプトが slider の scroll を監視して slider-counter__link--active を同期する。
 *
 * 命名規則: IIFE + data-c-* 属性駆動（グローバル汚染なし）
 * 対象:     slider-component.c-featured-blog__slider 内の [data-c-featured-blog-dots]
 * active class: slider-counter__link--active（component-slider.css 由来）
 */
(function () {
  'use strict';

  /**
   * ひとつの slider-component インスタンスをセットアップする。
   * @param {HTMLElement} sliderComponent - <slider-component> 要素
   */
  function initDots(sliderComponent) {
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var dotsWrapper = sliderComponent.querySelector('[data-c-featured-blog-dots]');

    if (!slider || !dotsWrapper) return;

    var dots = Array.from(dotsWrapper.querySelectorAll('.slider-counter__link'));
    if (!dots.length) return;

    var ACTIVE_CLASS = 'slider-counter__link--active';

    function updateActiveDot() {
      var slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function (el) {
        return el.clientWidth > 0;
      });
      if (!slides.length) return;

      // ScrollLeft ÷ 先頭スライド幅（offset ベース）で現在インデックスを算出
      var offset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;
      if (!offset) return;

      var index = Math.min(
        Math.round(slider.scrollLeft / offset),
        dots.length - 1
      );

      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.classList.add(ACTIVE_CLASS);
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove(ACTIVE_CLASS);
          dot.removeAttribute('aria-current');
        }
      });
    }

    // ドットボタンクリック → 対応スライドまでスクロール
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function (el) {
          return el.clientWidth > 0;
        });
        if (!slides.length || !slides[i]) return;
        slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { updateActiveDot(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    // ResizeObserver でスライドサイズ変化時も再評価
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateActiveDot).observe(slider);
    }

    // 初期状態を確定（最初のドットを active に）
    updateActiveDot();
  }

  function init() {
    var components = document.querySelectorAll('slider-component.c-featured-blog__slider');
    components.forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
